import { combineReducers } from 'redux';
import { router } from 'redux-ui-router';

import auth, { authLogic } from './auth';
import completions, { completionsLogic } from './completions';
import favourite, { favouriteLogic } from './favourite';
import filters, { filtersLogic } from './filters';
import mealPlan, { mealPlanLogic } from './mealPlan';
import member, { memberLogic } from './member';
import product, { productLogic } from './product';
import recipe, { recipeLogic } from './recipe';
import recipesSimilar, { recipesSimilarLogic } from './recipesSimilar';
import { redirectLogic } from './redirect';
import reviews, { reviewsLogic } from './reviews';
import search, { searchLogic } from './search';
import shoppingList, { shoppingListLogic } from './shoppingList';
import signup, { signupLogic } from './signup';
import theme from './theme';
import videoResume, { videoResumeLogic } from './videoResume';
import workout, { workoutLogic } from './workout';

// Combine logic
export const rootLogic = [
  ...authLogic,
  ...completionsLogic,
  ...favouriteLogic,
  ...filtersLogic,
  ...mealPlanLogic,
  ...memberLogic,
  ...productLogic,
  ...signupLogic,
  ...recipeLogic,
  ...recipesSimilarLogic,
  ...redirectLogic,
  ...reviewsLogic,
  ...searchLogic,
  ...shoppingListLogic,
  ...videoResumeLogic,
  ...workoutLogic,
];

// Combine reducers
export const rootReducer = combineReducers({
  auth,
  completions,
  favourite,
  filters,
  mealPlan,
  member,
  product,
  recipe,
  recipesSimilar,
  reviews,
  router,
  search,
  shoppingList,
  signup,
  theme,
  videoResume,
  workout,
});



// WEBPACK FOOTER //
// ./src/logic/index.js